import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiSourcesTestConnectionCacheKeys: AllRouteEndpoints[] = [];
